<template>
    <div id="accountWrapper">
        <div class="tabs">
            <ul>
                <li v-if="isAdmin" :class="{ 'is-active': activeTab === 'dashboard' }"><a @click="switchTab('dashboard')">Dashboard</a></li>
                <li :class="{ 'is-active': activeTab === 'profile' }"><a @click="switchTab('profile')">Account gegevens</a></li>
                <li :class="{ 'is-active': activeTab === 'programmes' }"><a @click="switchTab('programmes')">Programma's</a></li>
            </ul>
        </div>

        <template v-if="activeTab === 'programmes'">
            <programmes></programmes>
        </template>

        <template v-else-if="activeTab === 'dashboard'">
            <dashboard></dashboard>
        </template>

        <template v-else>
            <user-edit></user-edit>
            <supplier-edit v-if="isSupplier"></supplier-edit>
        </template>

    </div>
</template>

<script>
    import UserEdit from '@/components/users/UserEdit'
    import Dashboard from '@/components/users/Dashboard'
    import Programmes from '@/components/programmes/Programmes'
    import SupplierEdit from '@/components/suppliers/SupplierEdit'

    export default {
        created () {
            if (!this.$store.getters.isLoggedIn)
                this.$router.push('signin')
            },
        data () {
            return {
                activeTab: 'profile'
            }
        },
        computed: {
            isSupplier () {
                return this.$store.getters.isSupplier
            },
            isAdmin () {
                return this.$store.getters.isAdmin
            }
        },
        components: {
            UserEdit,
            SupplierEdit,
            Programmes,
            Dashboard
        },
        methods: {
            switchTab (tab) {
                this.activeTab = tab
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/auth/Account.vue